<template>
  <div class="col-sm-12 col-md-4">
    <img class="etiqueta" src="@/assets/etiqueta30off.png">
    <div :class="{ 'card-ribbon': popular }" class="card box-shadow shadow">
      <div v-if="popular" class="ribbon">Popular</div>
      <div class="card-header">
        <div class="mb-0 card-title" style="font-weight: 800">
          {{ name }}
          <hr class="linha linha-header">
        </div>
        <span class="m-0" style="opacity: 0.5; text-decoration: line-through; font-size: 18px;">
          R${{ originalPrice }}
        </span>
        <h4 class="m-0" style="font-weight: 800; font-size: 28px">R${{ promotionalPrice }}</h4>
        <div class="mb-2">
          <small>Por Mês</small>
          <hr class="linha linhas">
        </div>
      </div>
      <div class="card-body card-body-price">
        <ul class="list-unstyled text-center mb-4 text-left">
          <li v-for="(feature, index) in features" :key="genKey('included', index)">
            {{ feature }} <hr class="linha linhas"/>
          </li>
          <li v-for="(featureNotIncluded, index) in featuresNotIncluded" :key="genKey('notincluded', index)" style="opacity: 0.2; text-decoration: line-through;">
            {{ featureNotIncluded }}
            <hr class="linha linhas"/>
          </li>
        </ul>
      </div>
      <div class="card-footer">
        <a :href="checkout" class="btn btn-green btn-lg btn-block btn-action btn-action-green mt-0">Assine Já!</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    popular: { type: Boolean, default: false },
    name: { type: String, default: '' },
    originalPrice: { type: String },
    promotionalPrice: { type: String },
    features: { type: Array, default: () => [] },
    featuresNotIncluded: { type: Array, default: () => [] },
    checkout: { type: String, default: '' }
  },
  methods: {
    genKey: (name, index) => `${name}-${index + 1}`
  }
}
</script>
